<div *ngIf="!add" class="activity-wrapper">
  <curbnturf-activity-location-page [activity]="selectedActivity$ | async"> </curbnturf-activity-location-page>
</div>

<ng-container *ngIf="add">
  <curbnturf-add-activity-form (close)="saved()"></curbnturf-add-activity-form>
</ng-container>
